import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { base_url } from '../Api/Api';
import Skeletoncnt from '../Education/skeletonContent';
import Cookies from 'universal-cookie';

const Coursecnt = (props) => {

    const [state, setState] = useState({
        data: [],
        loader: true
    })
  const cookies =  new  Cookies()
    const [hasLink, setHasLink] = useState(false)
    const [hasVideo, setHasVideo] = useState(false)
    const [linksList, setLinksList] = useState([])
    useEffect(() => {
        
        if (cookies.get('api_key') == null) {
            props.history.push('/entrance')
        }
        window.scrollTo(0, 0)

      base_url.get(`tutorial/${props.match.params.id}`)
            .then(response => {
                setState({
                    ...state,
                    data: response.data,
                    loader: false
                })
                  let C =document.getElementsByClassName('webview')
                  let children = C[0].children
                  let list = []
                  for (var i=0 ; i < children.length ; i++ ){
                    if(children[i]){
                      if(children[i].childNodes[0]){
                        if(children[i].childNodes[0].attributes){
                          if(children[i].childNodes[0].attributes.href){
                            setHasLink(true)
                            list.push(children[i].childNodes[0].attributes)
                            // href.value
                            // title.value
                          }else if(children[i].childNodes[0].attributes.controls){
                            setHasVideo(true)
                            document.getElementsByTagName("video")[0].setAttribute("controlsList", "nodownload");
                          }
                        }
                      }
                    }

                  }
                  setLinksList(list)
            })
            .catch(error => {
				if (error.response != undefined) {
					if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
					}
				}
            })

    }, [])

    const openPdf = (e, href, title) =>{
      localStorage.setItem('pdfLink', href)
      localStorage.setItem('pdfTitle', title)
      props.history.push(`/education/course-content/${props.match.params.id}/pdfViewer`)
    }

    return (
        <div className="course-contenthtml">
            <div className="contain">
                <h4>{state.data.page_title}</h4>
                {state.data.length == 0 ?
                    <Skeletoncnt />
                    :
                    <>
                      <div className="inner-maincourses" dangerouslySetInnerHTML={{ __html: state.data.page_source }}></div>
                      {
                            (hasLink && linksList.length )
                              ?( <div className="pdfs">
                                {
                                linksList.map((item, index)=> (
                                  <div className="pdf-item">
                                    <button 
                                      className="btn pdf-btn" 
                                      id={index} 
                                      onClick={(e)=>openPdf(e,item.href.value,item.title.value )}
                                    >
                                      مشاهده {item.title.value} <i className="icon-arrow-down-sign-to-navigate"></i>
                                    </button>
                                  </div>
                                  )
                                )}
          
                              </div>)
                              :<></>
                          }
                    </>
                }
            </div>
        </div>
    );
}

export default withRouter(Coursecnt);